<template>
  <PageHeader title="我的优惠券" class="myCoupon">
    <div>
      <div>
        <el-row>
          <el-col :span="8" :key="item" v-for="(item, index) in usedCoupons">
            <div
              class="flex w300 space-around align-center pad10 mar20_b mar20_r"
              :class="
                index % 3 === 0
                  ? 'bg-theme-color'
                  : index % 3 === 1
                  ? 'bg-ff9000'
                  : 'bg-d6d6d6'
              "
            >
              <div class="flex white flex-direction pad20_r">
                <div class="flex space-between align-center mar20_b">
                  <div class="flex align-center">
                    ￥ <span class="f20">454545</span>
                  </div>
                  <div class="">
                    <span class="red-color bg-white pad5_lr mar10_r radius5"
                      >平台券</span
                    ><span class="red-color bg-white pad5_lr radius5 mar10_r"
                      >直减券</span
                    >
                  </div>
                </div>
                <div class="flex flex-direction">
                  <div><span>使用条件：</span> <span>满100减10元</span></div>
                  <div class="pad5_tb">
                    <span>使用条件：</span>
                    <span
                      >满100减10元满100减10元满100减10元满100减10元满100减10元</span
                    >
                  </div>
                  <div><span>使用条件：</span> <span>满100减10元</span></div>
                </div>
              </div>
              <div class="flex w10">
                <div class="dashed-white h100m "></div>
              </div>
              <div class="white w20 flex vercenter align-center">去使用</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pad10_tb">领取使用记录</div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="name" label="领取/使用"> </el-table-column>
        <el-table-column prop="date" label="日期"> </el-table-column>
        <el-table-column label="获得/消耗">
          <template slot-scope="scope">
            <span :class="scope.row.isAdd ? 'red-color' : ''"
              >{{ scope.row.isAdd ? "+" : "-" }}{{ scope.row.grade }}</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pad40 vercenter align-center">
      <el-image>
        <div slot="error">
          <i class="el-icon-picture-outline" size="20"></i>
        </div>
      </el-image>
      <div>很遗憾，你还没有店铺优惠券，马上去</div>
      <div class="red-color">领取</div>
    </div>
  </PageHeader>
</template>
<style lang="scss" scoped>
/* 买家中心优惠券 */
.dashed-white{
  border-right:1px dashed #fff;
  width:1px
}
</style>
<script>
export default {
  data() {
    return {
      usedCoupons: [
        {
          amount: '234', // 额度
          type: '1',
          typeCn: '平台券',
          condition: '使用条件MMMMMMMMMMMMMM',
          range: '使用范围MMMMMMMMM',
          validTime: '2020-12-11~2020-12-11',
          state: '0', // 0 可用 非0 不可用
          actionCn: '去使用',
        },
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
      ],
      tableData: [
        {
          date: '2016-05-02',
          name: '积分兑换',
          isAdd: true,
          grade: '20',
        },
        {
          date: '2016-05-04',
          name: '积分兑换',
          isAdd: false,
          grade: '20',
        },
        {
          date: '2016-05-01',
          name: '积分兑换',
          isAdd: true,
          grade: '20',
        },
        {
          date: '2016-05-03',
          name: '积分兑换',
          grade: '20',
          isAdd: false,
        },
      ],
    };
  },
};
</script>
